var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icono_2_Vista_6.7.2.",
    "data-name": "Icono (2) Vista 6.7.2.",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 35.556,
    viewBox: "0 0 40 35.556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_exclamation-triangle_",
    d: "M39.55,30.556a3.335,3.335,0,0,1-2.887,5H3.337a3.335,3.335,0,0,1-2.887-5L17.112,1.666a3.335,3.335,0,0,1,5.775,0L39.55,30.556ZM20,24.583a3.194,3.194,0,1,0,3.194,3.194A3.194,3.194,0,0,0,20,24.583ZM16.967,13.1l.515,9.444a.833.833,0,0,0,.832.788h3.371a.833.833,0,0,0,.832-.788l.515-9.444a.833.833,0,0,0-.832-.879H17.8a.833.833,0,0,0-.832.879Z",
    transform: "translate(0)",
    fill: "#f7b500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon-alert.ec402c74629968df197e0080f4a27d7c.svg";
export { ForwardRef as ReactComponent };